export class ContactNumber {
    public id: number;
    public contact_id: number;
    public reference_id: number;

    public number: string;
    public country_code: string;
    public type: string;
}
